import { Country } from '@front/common/src/types/commons';

import { SignupStep } from '@front/pro/src/hooks/use-signup-stepper';
import { WeeklyHours } from '@front/pro/src/types/pro';

export const parseQueryParams = (url?: string) => {
  if (!url) return {};
  const queryParams: Record<string, string> = {};
  const queryString = url.split('?')[1];
  if (!queryString) return {};

  const pairs = queryString.split('&');

  pairs.forEach((pair) => {
    const [key, value] = pair.split('=');
    const decodedKey = decodeURIComponent(key);
    const decodedValue = decodeURIComponent(value);

    queryParams[decodedKey] = decodedValue;
  });

  return queryParams;
};

export const numberToWeeklyHours = (hours: number): WeeklyHours => {
  if (hours < 10) return 'less_than_ten';
  if (hours >= 10 && hours < 20) return 'ten_to_twenty';
  if (hours >= 20 && hours < 30) return 'twenty_to_thirty';
  return 'more_than_thirty';
};

export const invertNestedRoutes = (routes: Record<Country, Record<SignupStep, string>>) => {
  const inverted: Record<Country, Record<string, SignupStep>> = {} as Record<Country, Record<string, SignupStep>>;

  Object.keys(routes).forEach((country) => {
    inverted[country as Country] = Object.fromEntries(
      Object.entries(routes[country as Country]).map(([key, value]) => [value, key as SignupStep]),
    ) as Record<string, SignupStep>;
  });

  return inverted;
};
